module.exports = __webpack_public_path__ + "img/1762097291723-WX7W-Xrm.28ff1731.png";